import rimg from '@pixelunion/rimg-shopify'; // eslint-disable-line
import AsyncView from 'shopify-asyncview';

export default class StaticProductRecommendations {
  constructor(section) {
    this.section = section;
    this.productId = section.data.productId;
    this.limit = section.data.settings.limit;

    this.recommendationContainer = document.querySelector('[data-product-recommendations]');

    this.recommendUrl = window.Theme.routes.product_recommendations_url;

    this.queryParams = {
      section_id: 'static-product-recommendations',
      limit: this.limit,
      product_id: this.productId,
      view: '',
    };

    this._loadRecommendations();
  }

  _loadRecommendations() {
    AsyncView.load(
      this.recommendUrl,
      this.queryParams,
    ).then(({ data, html }) => {
      this.recommendationContainer.innerHTML = html;

      rimg.watch(this.recommendationContainer);
    });
  }
}
